import { MarketMessagePreSwitchEanDataRequestQueryStringParams, MarketMessagePreSwitchEanDataResponseBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'
import { stringify } from 'qs'
import dayjs from 'dayjs'

export const getEanData = async ({
  ean,
  energyType,
  contractStartDate
}: MarketMessagePreSwitchEanDataRequestQueryStringParams): Promise<NextApiResponseBody<MarketMessagePreSwitchEanDataResponseBody>> => {
  try {
    const query = stringify(
      { ean, energyType, contractStartDate: contractStartDate ? dayjs(contractStartDate).format('YYYY-MM-DD') : null },
      { skipNulls: true }
    )
    const res = await fetch(`/api/utilities/market-message/pre-switch/ean-data?${query}`, {
      method: 'GET'
    })

    return (await res.json()) as NextApiResponseBody<MarketMessagePreSwitchEanDataResponseBody>
  } catch (error) {
    return { success: false }
  }
}
